import { useEffect, useRef } from "react";

const STOP_STATES = new Set(["STAGED", "REJECTED", "CANCELLED", "COMPLETED", "COMPLETED_WITH_ERRORS", "FAILED", "RECOVERY_REQUIRED"]);

const useImportPolling = ({ enabled, load, onUpdate, onDenied, initialDelay = 1000, maxDelay = 10000 }) => {
  const timer = useRef(null);
  useEffect(() => {
    if (!enabled || !load) return undefined;
    let cancelled = false;
    let delay = initialDelay;
    const poll = async () => {
      try {
        const value = await load();
        if (cancelled) return;
        onUpdate(value);
        const state = value && (value.state || (value.run && value.run.state));
        if (STOP_STATES.has(state)) return;
        delay = Math.min(maxDelay, Math.round(delay * 1.5));
      } catch (error) {
        if (cancelled) return;
        if (error && (error.status === 403 || error.status === 404)) {
          if (onDenied) onDenied(error);
          return;
        }
      }
      timer.current = window.setTimeout(poll, delay);
    };
    timer.current = window.setTimeout(poll, initialDelay);
    return () => {
      cancelled = true;
      if (timer.current) window.clearTimeout(timer.current);
    };
  }, [enabled, initialDelay, load, maxDelay, onDenied, onUpdate]);
};

export default useImportPolling;
